import Vue from 'vue'
import Router from 'vue-router'
//import Login from '@/page/login'
import Index from '@/page/index'
import IndexN from '@/page/indexN'
import News from '@/page/news/news'
import NewsN from '@/page/news/newsN'
import NewsDetailDw from '@/page/news/newsDetaildw'
import newsTaskDetails from '@/page/news/newsTaskDetails'
import NewsDetail from '@/page/news/newsDetail'
import TransPath from '@/page/news/transPath'
import Events from '@/page/event/event'
import EventsN from '@/page/event/eventN'
import EveningPaper from '@/page/event/eveningPaper'
import EveningPaperN from '@/page/event/eveningPaperN'
import EventTag from '@/page/event/eventTag'
import EventDetail from '@/page/event/eventDetail'
import Viewpoint from '@/page/point/viewpoint'
import PointDetail from '@/page/point/pointDetail'
import TransIndex from '@/page/trans/transIndex'
import TransDetail from '@/page/trans/transDetail'
import Knowledge from '@/page/knowledge'
import MyFavorites from '@/page/myFavorites'
import EmotionArea from '@/page/emotionArea'
 import Events_test from '@/page/event/event_test'
Vue.use(Router)

export default new Router({
    // pageType判断页面属于哪个导航分类
    // keepAlive 不同页面的颜色 首页1
    mode: 'history',  //去掉url中的#
    routes: [
        // {
        //     path: '/login',
        //     name: 'login',
        //     component: Login,
        //     meta:{
        //         title:'舆情热点',
        //         requireAuth: false,//登录状态
        //         topShow:false,
        //         keepAlive:1,
        //     }
        // },
        /**首页**/
        {
            path: '/',
            name: 'index',
            component: Index,
            meta:{
                title:'热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:true,
                keepAlive:2,
            }
        },
        //无头尾加key
        {
            path: '/indexN',
            name: 'indexn',
            component: IndexN,
            meta:{
                title:'区域热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:2,
                pageType:1,
            }
        },
        /**读数据**/
        {
            path: '/news',
            name: 'news',
            component: News,
            meta:{
                title:'读数据_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:true,
                keepAlive:2,
                pageType:2,
            },
        },
        // 无头尾加key
        {
            path: '/newsn',
            name: 'newsn',
            component: NewsN,
            meta:{
                title:'读数据',
                requireAuth: false,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:2,
                pageType:3,
            },
        },
        {
            path: '/newsDetail',
            name: 'newsDetail',
            component: NewsDetail,
            meta:{
                title:'详情_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:true,
                keepAlive:2,
                pageType:2,
            },
        },
        {
            path: '/newsDetails',
            name: 'newsDetailDw',
            component: NewsDetailDw,
            meta:{
                title:'详情',
                requireAuth: false,//登录状态
                topShow:false,
                footShow:false,
                keepAlive:4,
                pageType:2,
            }
        },
        {
            path: '/newsFor2021',
            name: 'newsTaskDetails',
            component: newsTaskDetails,
            meta:{
                title:'详情_热点',
                requireAuth: false,//登录状态
                topShow:false,
                footShow:false,
                keepAlive:4,
                pageType:2,
            }
        },
        {
            path: '/transPath',
            name: 'transPath',
            component: TransPath,
            meta:{
                title:'详情_热点',
                requireAuth: false,//登录状态
                topShow:false,
                footShow:false,
                keepAlive:4,
                pageType:2,
            }
        },
       /**看事件**/
        {
            path: '/events',
            name: 'events',
            component: Events,
            meta:{
                title:'看事件_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:2,
                pageType:3
            }
        },
         // 无头尾加key
         {
            path: '/eventsn',
            name: 'eventsn',
            component: EventsN,
            meta:{
                title:'看事件',
                requireAuth: false,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:2,
                pageType:2,
            },
        },
        {
            path: '/eveningPaper',
            name: 'eveningPaper',
            component: EveningPaper,
            meta:{
                title:'晨晚报_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:2,
                pageType:6
            }
        },
        // 无头尾加key
        {
            path: '/eveningPaperN',
            name: 'eveningPaperN',
            component: EveningPaperN,
            meta:{
                title:'晨晚报',
                requireAuth: false,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:2,
                pageType:6
            }
        },
        /**事件标签**/
        {
            path: '/eventTag',
            name: 'eventTag',
            component: EventTag,
            meta:{
                title:'标签_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:2,
                pageType:6
            }
        },
        {
            path: '/eventDetail',
            name: 'eventDetail',
            component: EventDetail,
            meta:{
                title:'详情_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:2,
                pageType:3,
                shuYu:'event'//所属
            }
        },

        /**说观点**/
        {
            path: '/viewpoint',
            name: 'viewpoint',
            component: Viewpoint,
            meta:{
                title:'说观点_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:2,
                pageType:4
            }
        },
        {
            path: '/pointDetail',
            name: 'pointDetail',
            component: PointDetail,
            meta:{
                title:'说观点详情_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:2,
                pageType:4,
                shuYu:'event'//所属
            }
        },
        /**全网传播指数**/
        {
            path: '/transIndex',
            name: 'transIndex',
            component: TransIndex,
            meta:{
                title:'全网传播指数_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:3,
                pageType:5
            }
        },
        {
            path: '/transDetail',
            name: 'transDetail',
            component: TransDetail,
            meta:{
                title:'全网传播指数详情_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:2,
                pageType:5
            }
        },
        /**知识图谱**/
        {
            path: '/knowledge',
            name: 'knowledge',
            component: Knowledge,
            meta:{
                title:'知识图谱_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:5,
                pageType:7
            }
        },
        /**我的收藏**/
        {
            path: '/myFavorites',
            name: 'myFavorites',
            component: MyFavorites,
            meta:{
                title:'我的收藏_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:true,
                keepAlive:2,
                pageType:7
            }
        },
         /**情绪区域**/
         {
            path: '/emotionArea',
            name: 'emotionArea',
            component: EmotionArea,
            meta:{
                title:'情绪区域_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:true,
                keepAlive:2,
                pageType:7
            }
        },
        {
            path: '/events_test',
            name: 'events_test',
            component: Events_test,
            meta:{
                title:'看事件_热点',
                requireAuth: true,//登录状态
                topShow:true,
                footShow:false,
                keepAlive:2,
                pageType:3
            }
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js